module.exports = __webpack_public_path__ + "img/icon-red-warning.6db86982.svg";